import { Avatar, Button, Container, styled, Typography } from "@mui/material";
import { Form, useFormikContext } from "formik";
import shortid from "shortid";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { SelectInput } from "../../../Input/FormControl";
import { apiSetAlert } from "../../../../api/appApi";
import { apiAddPersonsExcel } from "../../../../api/personApi";
import { useNavigate } from "react-router-dom";
import { excelSetItems, excelSetTab } from "../../../../store/actions/excelAction";
import { apiAddPriceListExcel, apiAddProductsExcel } from "../../../../api/productApi";
import { apiAddFinancialExcel, apiAddFinancialsExcel } from "../../../../api/financialApi";
import { apiAddWarehousesExcel } from "../../../../api/warehouseApi";
import { apiAddAccountingByExcel } from "api/accountingApi";
import { apiSaveFactorBuyByExcel, apiSaveFactorByExcel } from "api/factorApi";
import { apiSetOpeningBalance } from "api/openingBalanceApi";
const UploadComponentContainer = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    gridTemplateColumns: "50% 40%",
    flexDirection: "column", gap: '50px'
}));
const TableElementsContainer = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
    // overflowY: 'auto',
    display: "grid",
    gridTemplateColumns: "32% 56%",
    justifyContent: "space-between",
    maxHeight: "60vh",
    minHeight: "445px",
    paddingBottom: "20px",
    overflow: "auto",
}));
const TableLablesItemContainer = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
    // display: 'flex',
    // overflowY: 'auto',
    // flexDirection: 'column',
}));
const TableValuesItemContainer = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
    // border: '1px solid #C2D0E3',
    maxHeight: "60vh",
    minHeight: "445px",
    paddingBottom: "20px",
    gridTemplateColumns: "40% 40%",
    justifyContent: "space-between",
}));
const LabelItem = styled("div")(({ theme }) => ({
    // height: '48px',
    height: "38px",
    margin: "5px 0",
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    border: "1px solid #C2D0E3",
}));
const StyledSelect = styled("div")(({ theme }) => ({
    // border: `1px solid #C2D0E3`,
    // borderRadius: '4px',
    height: "38px !important",
    margin: "5px 0",
    width: "100%",
}));
const LabelHeader = styled(LabelItem)(({ theme }) => ({
    backgroundColor: "#C2D0E3",
    justifyContent: "space-between",
}));
const LabelBodyItem = styled(LabelItem)(({ theme }) => ({
    borderBottom: `2px solid ${theme.palette.primary.main}`,
}));
const ProductListContainer = styled("div")(({ theme }) => ({
    width: "100%",
    // height: '100%',
    maxHeight: "60vh",
    minHeight: "445px",
    paddingBottom: "20px",
    borderRadius: "4px",
    display: "grid",
    // gridTemplateRows: '10% 90%',
    boxShadow: "0px 2px 14px rgba(16, 98, 208, 0.09)",
}));
const ProductList = styled("div")(({ theme }) => ({
    padding: "10px",
    height: "100%",
    display: "flex",
    overflowY: "auto",
    flexDirection: "column",
}));
const ProductItem = styled("div")(({ theme }) => ({
    borderRadius: "4px",
    // height: '48px',
    height: "38px",
    margin: "5px 0",
    padding: "0 10px",
    border: "2px solid #d5ddfe",
    display: "flex",
    alignItems: "center",
}));
const ProductLabelContainer = styled("div")(({ theme }) => ({
    // height: '48px !important',
    height: "38px",
    margin: "5px 0",
    width: "100%",
    display: "flex",
    alignItems: "center",
    borderRadius: "4px 4px 0px 0px",
    boxShadow: "0px 2px 14px rgba(16, 98, 208, 0.09)",
    padding: "0 10px",
}));
const ProductAvatar = styled(Avatar)(({ theme }) => ({
    width: "32px",
    marginLeft: "10px",
    height: "32px",
}));
const initialValues = {};
const onSubmit = (values: typeof initialValues) => { };

export const tables = [
    {
        name: "customer",
        value: "customer",
        label: "مشتری",
        addFunction: apiAddPersonsExcel,
        form: {
            table: "customer",
            modelTitleKey: "nickName",
            modelName: "مشتری",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "isLegal",
                    label: "نوع شخص",
                    required: true,
                    primary: true,
                    // options: [
                    //     {
                    //         label: "حقیقی",
                    //         value: "حقیقی",
                    //     },
                    //     {
                    //         label: "حقوقی",
                    //         value: "حقوقی",
                    //     },
                    // ],
                },
                {
                    name: "firstName",
                    label: "نام",
                    required: true,
                    primary: true,
                },
                {
                    name: "lastName",
                    label: "نام خانوادگی",
                    required: true,
                    primary: true,
                },
                {
                    name: "nickName",
                    label: "نام نمایشی",
                    required: true,
                    primary: true,
                },
                {
                    name: "financialCredit",
                    label: "اعتبار مالی",
                    required: false,
                    primary: true,
                },
                {
                    name: "tax",
                    label: "مالیات (درصد)",
                    required: false,
                    primary: false,
                },
                {
                    name: "country",
                    label: "کشور",
                    required: false,
                    primary: false,
                },
                {
                    name: "state",
                    label: "استان",
                    required: false,
                    primary: false,
                },
                {
                    name: "city",
                    label: "شهر",
                    required: false,
                    primary: false,
                },
                {
                    name: "postalCode",
                    label: "کد پستی",
                    required: false,
                    primary: false,
                },
                {
                    name: "address",
                    label: "آدرس",
                    required: false,
                    primary: false,
                },
                {
                    name: "phone",
                    label: "تلفن",
                    required: false,
                    primary: false,
                },
                {
                    name: "mobile",
                    label: "موبایل",
                    required: false,
                    primary: false,
                },
                {
                    name: "email",
                    label: "ایمیل",
                    required: false,
                    primary: false,
                },
                {
                    name: "website",
                    label: "وبسایت",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankName",
                    label: "بانک",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankAccountNumber",
                    label: "شماره حساب",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankCardNumber",
                    label: "شماره کارت",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankShaba",
                    label: "شماره شبا",
                    required: false,
                    primary: false,
                },
                {
                    name: "nationalId",
                    label: "کد شناسه ملی",
                    required: false,
                    primary: false,
                },
                {
                    name: "economicCode",
                    label: "کد اقتصادی",
                    required: false,
                    primary: false,
                },
            ],
        },
    },
    {
        name: "personnel",
        value: "personnel",
        label: "کارمند",
        addFunction: apiAddPersonsExcel,
        form: {
            table: "personnel",
            modelTitleKey: "nickName",
            modelName: "کارمند",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "firstName",
                    label: "نام",
                    required: true,
                    primary: true,
                },
                {
                    name: "lastName",
                    label: "نام خانوادگی",
                    required: true,
                    primary: true,
                },
                {
                    name: "nickName",
                    label: "نام نمایشی",
                    required: true,
                    primary: true,
                },
                {
                    name: "financialCredit",
                    label: "اعتبار مالی",
                    required: false,
                    primary: false,
                },
                {
                    name: "tax",
                    label: "مالیات (درصد)",
                    required: false,
                    primary: false,
                },
                {
                    name: "country",
                    label: "کشور",
                    required: false,
                    primary: false,
                },
                {
                    name: "state",
                    label: "استان",
                    required: false,
                    primary: false,
                },
                {
                    name: "city",
                    label: "شهر",
                    required: false,
                    primary: false,
                },
                {
                    name: "postalCode",
                    label: "کد پستی",
                    required: false,
                    primary: false,
                },
                {
                    name: "address",
                    label: "آدرس",
                    required: false,
                    primary: false,
                },
                {
                    name: "phone",
                    label: "تلفن",
                    required: false,
                    primary: false,
                },
                {
                    name: "mobile",
                    label: "موبایل",
                    required: false,
                    primary: false,
                },
                {
                    name: "email",
                    label: "ایمیل",
                    required: false,
                    primary: false,
                },
                {
                    name: "website",
                    label: "وبسایت",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankName",
                    label: "بانک",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankAccountNumber",
                    label: "شماره حساب",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankCardNumber",
                    label: "شماره کارت",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankShaba",
                    label: "شماره شبا",
                    required: false,
                    primary: false,
                },
            ],
        },
    },
    {
        name: "provider",
        value: "provider",
        label: "تامین کننده",
        addFunction: apiAddPersonsExcel,
        form: {
            table: "provider",
            modelTitleKey: "nickName",
            modelName: "تامین کننده",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "isLegal",
                    label: "نوع شخص",
                    required: true,
                    primary: true,
                    // options: [
                    //     {
                    //         label: "حقیقی",
                    //         value: "حقیقی",
                    //     },
                    //     {
                    //         label: "حقوقی",
                    //         value: "حقوقی",
                    //     },
                    // ],
                },
                {
                    name: "firstName",
                    label: "نام",
                    required: true,
                    primary: true,
                },
                {
                    name: "lastName",
                    label: "نام خانوادگی",
                    required: true,
                    primary: true,
                },
                {
                    name: "nickName",
                    label: "نام نمایشی",
                    required: true,
                    primary: true,
                },
                {
                    name: "financialCredit",
                    label: "اعتبار مالی",
                    required: false,
                    primary: false,
                },
                {
                    name: "tax",
                    label: "مالیات (درصد)",
                    required: false,
                    primary: false,
                },
                {
                    name: "country",
                    label: "کشور",
                    required: false,
                    primary: false,
                },
                {
                    name: "state",
                    label: "استان",
                    required: false,
                    primary: false,
                },
                {
                    name: "city",
                    label: "شهر",
                    required: false,
                    primary: false,
                },
                {
                    name: "postalCode",
                    label: "کد پستی",
                    required: false,
                    primary: false,
                },
                {
                    name: "address",
                    label: "آدرس",
                    required: false,
                    primary: false,
                },
                {
                    name: "phone",
                    label: "تلفن",
                    required: false,
                    primary: false,
                },
                {
                    name: "mobile",
                    label: "موبایل",
                    required: false,
                    primary: false,
                },
                {
                    name: "email",
                    label: "ایمیل",
                    required: false,
                    primary: false,
                },
                {
                    name: "website",
                    label: "وبسایت",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankName",
                    label: "بانک",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankAccountNumber",
                    label: "شماره حساب",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankCardNumber",
                    label: "شماره کارت",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankShaba",
                    label: "شماره شبا",
                    required: false,
                    primary: false,
                },
                {
                    name: "nationalId",
                    label: "کد شناسه ملی",
                    required: false,
                    primary: false,
                },
                {
                    name: "economicCode",
                    label: "کد اقتصادی",
                    required: false,
                    primary: false,
                },
            ],
        },
    },
    {
        name: "product",
        value: "product",
        label: "کالا",
        linkExample: "https://chortke.app/desktop/import_product_guide.xlsx",
        addFunction: apiAddProductsExcel,
        form: {
            table: "product",
            modelTitleKey: "title",
            modelName: "کالا",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "title",
                    label: "نام",
                    required: true,
                    primary: true,
                },
                {
                    name: "CategoryId",
                    label: "دسته بندی",
                    required: false,
                    primary: true
                },
                {
                    name: "barcode",
                    label: "بارکد",
                    required: false,
                    primary: true,
                },
                {
                    name: "code",
                    label: "کد کالا",
                    required: false,
                    primary: true,
                },
                {
                    name: "sellPrice",
                    label: "قیمت فروش",
                    required: false,
                    primary: true,
                },
                {
                    name: "salesDescription",
                    label: "توضیحات قیمت فروش",
                    required: false,
                    primary: false,
                },
                {
                    name: "buyPrice",
                    label: "قیمت خرید",
                    required: false,
                    primary: true,
                },
                {
                    name: "buyDescription",
                    label: "توضیحات قیمت خرید",
                    required: false,
                    primary: false,
                },
                {
                    name: "unit",
                    label: "واحد اصلی",
                    required: false,
                    primary: true,
                },
                {
                    name: "subUnit",
                    label: "واحد فرعی",
                    required: false,
                    primary: true,
                },
                {
                    name: "conversionRatio",
                    label: "ضریب تبدیل",
                    required: false,
                    primary: true,
                },
                {
                    name: "orderPoint",
                    label: "یادآوری سفارش",
                    required: false,
                    primary: false,
                },
                {
                    name: "minOrder",
                    label: "حداقل سفارش",
                    required: false,
                    primary: false,
                },
                {
                    name: "waitingTime",
                    label: "زمان تحویل (روز)",
                    required: false,
                    primary: false,
                },
                {
                    name: "address",
                    label: "آدرس",
                    required: false,
                    primary: false,
                },
                {
                    name: "saleTax",
                    label: "مالیات فروش (درصد)",
                    required: false,
                    primary: true,
                },
                {
                    name: "buyTax",
                    label: "مالیات خرید (درصد)",
                    required: false,
                    primary: true,
                },
                {
                    name: "taxCode",
                    label: "شناسه مالیاتی",
                    required: false,
                    primary: false,
                },
                {
                    name: "is_public",
                    label: "غیر قابل فروش",
                    required: false,
                    primary: false,
                },
            ],
        },
    },
    //////////////////////////ojaghi
    {
        name: "pricePlane",
        value: "pricePlane",
        label: "لیست قیمت",
        addFunction: apiAddPriceListExcel,
        form: {
            table: "pricePlane",
            modelTitleKey: "title",
            modelName: "لیست قیمت",
            modelTitles: [
                {
                    name: "productId",
                    label: "شناسه کالا",
                    required: false,
                    primary: true,
                },
                {
                    label: "کد کالا",
                    name: "productAccountingCode",
                    required: false,
                    primary: true,
                },
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    label: "شناسه لیست قیمت",
                    name: "pricePlanId",
                    required: false,
                    primary: true,
                },
                {
                    label: "کد لیست قیمت",
                    name: "code",
                    required: false,
                    primary: true,
                },
                {
                    label: "قیمت کالا",
                    name: "price",
                    required: true,
                    primary: true,
                },
            ],
        },
    },
    //
    {
        name: "service",
        value: "service",
        label: "خدمات",
        linkExample: "https://chortke.app/desktop/import_service_guide.xlsx",
        addFunction: apiAddProductsExcel,
        form: {
            table: "service",
            modelTitleKey: "title",
            modelName: "محصولات",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "title",
                    label: "نام خدمات",
                    required: true,
                    primary: true,
                },
                {
                    name: "barcode",
                    label: "بارکد",
                    required: false,
                    primary: true,
                },
                {
                    name: "code",
                    label: "کد خدمات",
                    required: false,
                    primary: true,
                },
                {
                    name: "CategoryId",
                    label: "دسته بندی",
                    required: false,
                    primary: true
                },
                {
                    name: "sellPrice",
                    label: "قیمت فروش",
                    required: false,
                    primary: true,
                },
                {
                    name: "salesDescription",
                    label: "توضیحات قیمت فروش",
                    required: false,
                    primary: false,
                },
                {
                    name: "unit",
                    label: "واحد اصلی",
                    required: false,
                    primary: true,
                },
                {
                    name: "mainUnitDescription",
                    label: "توضیحات واحد اصلی",
                    required: false,
                    primary: true,
                },
                {
                    name: "saleTax",
                    label: "مالیات فروش (درصد)",
                    required: false,
                    primary: false,
                },
                {
                    name: "saleTaxDescription",
                    label: "توضیحات مالیات فروش",
                    required: false,
                    primary: false,
                },
                {
                    name: "taxCode",
                    label: "شناسه مالیاتی",
                    required: false,
                    primary: false,
                },
                {
                    name: "taxUnit",
                    label: "واحد سنجش مالیاتی",
                    required: false,
                    primary: false,
                },
            ],
        },
    },
    {
        name: "bank",
        value: "bank",
        label: "بانک ها",
        addFunction: apiAddFinancialsExcel,
        form: {
            table: "bank",
            modelTitleKey: "name",
            modelName: "بانک",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "name",
                    label: "نام",
                    required: true,
                    primary: true,
                },
                {
                    name: "bankName",
                    label: "بانک",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankAccountNumber",
                    label: "شماره حساب",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankCardNumber",
                    label: "شماره کارت",
                    required: false,
                    primary: false,
                },
                {
                    name: "bankShaba",
                    label: "شماره شبا",
                    required: false,
                    primary: false,
                },
            ],
        },
    },
    {
        name: "fund",
        value: "fund",
        label: "تنخواه گردان",
        addFunction: apiAddFinancialExcel,
        form: {
            table: "fund",
            modelTitleKey: "fund",
            modelName: "تنخواه گردان",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "name",
                    label: "نام",
                    required: true,
                    primary: true,
                },
            ],
        },
    },
    {
        name: "cashier",
        value: "cashier",
        label: "صندوق",
        addFunction: apiAddFinancialExcel,
        form: {
            table: "cashier",
            modelTitleKey: "name",
            modelName: "صندوق",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "name",
                    label: "نام",
                    required: true,
                    primary: true,
                },
            ],
        },
    },
    {
        name: "inventory",
        value: "inventory",
        label: "انبار",
        addFunction: apiAddWarehousesExcel,
        form: {
            table: "inventory",
            modelTitleKey: "title",
            modelName: "انبار",
            modelTitles: [
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "title",
                    label: "نام",
                    required: true,
                    primary: true,
                },
                {
                    name: "warehouseKeeper",
                    label: "انباردار",
                    required: false,
                    primary: false,
                },
                {
                    name: "phone",
                    label: "تلفن",
                    required: false,
                    primary: false,
                },
                {
                    name: "address",
                    label: "آدرس",
                    required: false,
                    primary: false,
                },
            ],
        },
    },
    {
        name: "accounting",
        value: "accounting",
        label: "سند حسابداری",
        linkExample: "https://chortke.app/desktop/import_accounting_guide.xls",
        addFunction: apiAddAccountingByExcel,
        form: {
            table: "accounting",
            modelTitleKey: "title",
            modelName: "سند حسابداری",
            modelTitles: [
                {
                    name: "voucherHeaderId",
                    label: "شماره یکتای سند حسابداری",
                    required: true,
                    primary: true,
                },
                {
                    name: "BranchId",
                    label: "شناسه شعبه",
                    required: false,
                    primary: true,
                },
                {
                    name: "ProjectId",
                    label: "شناسه پروژه",
                    required: false,
                    primary: true,
                },
                {
                    name: "date",
                    label: "تاریخ سند حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "reference",
                    label: "ارجاع",
                    required: false,
                    primary: false,
                },
                {
                    name: "descriptionHeader",
                    label: "توضیحات",
                    required: true,
                    primary: true,
                },
                {
                    name: "accountTypeId",
                    label: "شناسه حساب",
                    required: false,
                    primary: true,
                },
                {
                    name: "accountTypeCode",
                    label: "کد حساب",
                    required: false,
                    primary: true,
                },
                {
                    name: "creditor",
                    label: "بستانکار",
                    required: false,
                    primary: true,
                },
                {
                    name: "debtor",
                    label: "بدهکار",
                    required: false,
                    primary: true,
                },
                {
                    name: "description",
                    label: "شرح ردیف",
                    required: false,
                    primary: true,
                },
                {
                    name: "detailId",
                    label: "شناسه تفصیلی",
                    required: false,
                    primary: true,
                },
                {
                    name: "detailCode",
                    label: "کد تفصیلی",
                    required: false,
                    primary: true,
                },
            ],
        },
    },
    {
        name: "factor",
        value: "factor",
        label: "فاکتور فروش",
        //linkExample:"https://chortke.app/desktop/import_accounting_guide.xls",
        addFunction: apiSaveFactorByExcel,
        form: {
            table: "factor",
            modelTitleKey: "title",
            modelName: "فاکتور فروش",
            modelTitles: [
                {
                    name: "voucherHeaderId",
                    label: "شماره یکتای فاکتور فروش",
                    required: true,
                    primary: true,
                },
                {
                    name: "PersonId",
                    label: "شناسه شخص",
                    required: false,
                    primary: true,
                },
                {
                    name: "personAccountingCode",
                    label: "کد شخص",
                    required: false,
                    primary: true,
                },

                {
                    name: "date",
                    label: "تاریخ",
                    required: false,
                    primary: true,
                },
                {
                    name: "dueDate",
                    label: "تاریخ سر رسید",
                    required: false,
                    primary: true,
                },
                {
                    name: "title",
                    label: "عنوان فاکتور",
                    required: false,
                    primary: true,
                },

                {
                    name: "ProjectId",
                    label: "شناسه پروژه",
                    required: false,
                    primary: true,
                },
                {
                    name: "BranchId",
                    label: "شناسه شعبه",
                    required: false,
                    primary: true,
                },
                // {
                //     name: "projectAccountingCod",
                //     label: "کد پروژه",
                //     required: false,
                //     primary: true,
                // },
                // {
                //     name: "branchAccountingCode",
                //     label: "کد شعبه",
                //     required: false,
                //     primary: true,
                // },
                {
                    name: "taxType",
                    label: "نوع صورتحساب",
                    required: false,
                    primary: true,
                },
                {
                    name: "SellerId",
                    label: " شناسه فروشنده",
                    required: false,
                    primary: true,
                },
                {
                    name: "sellerAccountingCode",
                    label: "کد فروشنده",
                    required: false,
                    primary: true,
                },
                {
                    name: "transferPrice",
                    label: "هزینه حمل نقل",
                    required: false,
                    primary: false,
                },
                {
                    name: "prsentSellerCommission",
                    label: "پورسانت درصدی",
                    required: false,
                    primary: true,
                },

                {
                    name: "currencySellerCommission",
                    label: "پورسانت ریالی",
                    required: false,
                    primary: true,
                },
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "currencyId",
                    label: "نوع ارز",
                    required: false,
                    primary: true,
                },

                {
                    name: "reference",
                    label: "ارجاع",
                    required: false,
                    primary: false,
                },
                {
                    name: "descriptionHeader",
                    label: "توضیحات",
                    required: true,
                    primary: true,
                },
                {
                    name: "productAccountingCode",
                    label: "کد کالا",
                    required: false,
                    primary: true,
                },
                {
                    name: "productId",
                    label: "شناسه کالا",
                    required: false,
                    primary: true,
                },
                {
                    name: "WarehouseId",
                    label: "شناسه انبار",
                    required: false,
                    primary: true,
                },
                {
                    name: "WarehouseAccountingCode",
                    label: "کد انبار",
                    required: false,
                    primary: true,
                },
                {
                    name: "descriptionItem",
                    label: "شرح ردیف",
                    required: false,
                    primary: true,
                },
                {
                    name: "quantity",
                    label: "مقدار",
                    required: false,
                    primary: true,
                },
                {
                    name: "price",
                    label: "قیمت",
                    required: false,
                    primary: true,
                },
                {
                    name: "unit",
                    label: "واحد",
                    required: false,
                    primary: true,
                },
                {
                    name: "tax",
                    label: "مالیات",
                    required: false,
                    primary: true,
                },
                {
                    name: "discount",
                    label: "تخفیف",
                    required: false,
                    primary: true,
                },


            ],
        },
    },
    {
        name: "factorBuy",
        value: "factorBuy",
        label: "فاکتور خرید",
        //linkExample:"https://chortke.app/desktop/import_accounting_guide.xls",
        addFunction: apiSaveFactorBuyByExcel,
        form: {
            table: "factorBuy",
            modelTitleKey: "title",
            modelName: "فاکتور خرید",
            modelTitles: [
                {
                    name: "voucherHeaderId",
                    label: "شماره یکتای فاکتور فروش",
                    required: true,
                    primary: true,
                },
                {
                    name: "PersonId",
                    label: "شناسه شخص",
                    required: false,
                    primary: true,
                },
                {
                    name: "personAccountingCode",
                    label: "کد شخص",
                    required: false,
                    primary: true,
                },

                {
                    name: "date",
                    label: "تاریخ",
                    required: false,
                    primary: true,
                },
                {
                    name: "dueDate",
                    label: "تاریخ سر رسید",
                    required: false,
                    primary: true,
                },
                {
                    name: "title",
                    label: "عنوان فاکتور",
                    required: false,
                    primary: true,
                },

                {
                    name: "ProjectId",
                    label: "شناسه پروژه",
                    required: false,
                    primary: true,
                },
                {
                    name: "BranchId",
                    label: "شناسه شعبه",
                    required: false,
                    primary: true,
                },
                // {
                //     name: "projectAccountingCod",
                //     label: "کد پروژه",
                //     required: false,
                //     primary: true,
                // },
                // {
                //     name: "branchAccountingCode",
                //     label: "کد شعبه",
                //     required: false,
                //     primary: true,
                // },
                // {
                //     name: "taxType",
                //     label: "نوع صورتحساب",
                //     required: false,
                //     primary: true,
                // },
                // {
                //     name: "SellerId",
                //     label: " شناسه فروشنده",
                //     required: false,
                //     primary: true,
                // },
                // {
                //     name: "sellerAccountingCode",
                //     label: "کد فروشنده",
                //     required: false,
                //     primary: true,
                // },
                {
                    name: "transferPrice",
                    label: "هزینه حمل نقل",
                    required: false,
                    primary: false,
                },
                // {
                //     name: "prsentSellerCommission",
                //     label: "پورسانت درصدی",
                //     required: false,
                //     primary: true,
                // },

                // {
                //     name: "currencySellerCommission",
                //     label: "پورسانت ریالی",
                //     required: false,
                //     primary: true,
                // },
                {
                    name: "accountingCode",
                    label: "کد حسابداری",
                    required: false,
                    primary: true,
                },
                {
                    name: "currencyId",
                    label: "نوع ارز",
                    required: false,
                    primary: true,
                },

                {
                    name: "reference",
                    label: "ارجاع",
                    required: false,
                    primary: false,
                },
                {
                    name: "descriptionHeader",
                    label: "توضیحات",
                    required: true,
                    primary: true,
                },
                {
                    name: "productAccountingCode",
                    label: "کد کالا",
                    required: false,
                    primary: true,
                },
                {
                    name: "productId",
                    label: "شناسه کالا",
                    required: false,
                    primary: true,
                },
                {
                    name: "WarehouseId",
                    label: "شناسه انبار",
                    required: false,
                    primary: true,
                },
                {
                    name: "WarehouseAccountingCode",
                    label: "کد انبار",
                    required: false,
                    primary: true,
                },
                {
                    name: "descriptionItem",
                    label: "شرح ردیف",
                    required: false,
                    primary: true,
                },
                {
                    name: "quantity",
                    label: "مقدار",
                    required: false,
                    primary: true,
                },
                {
                    name: "price",
                    label: "قیمت",
                    required: false,
                    primary: true,
                },
                {
                    name: "unit",
                    label: "واحد",
                    required: false,
                    primary: true,
                },
                {
                    name: "tax",
                    label: "مالیات",
                    required: false,
                    primary: true,
                },
                {
                    name: "discount",
                    label: "تخفیف",
                    required: false,
                    primary: true,
                },


            ],
        },
    },
    {
        name: "importOpeningBalance",
        value: "importOpeningBalance",
        label: "تراز افتتاحیه",
        //linkExample:"https://chortke.app/desktop/import_accounting_guide.xls",
        addFunction: apiSetOpeningBalance,
        form: {
            table: "importOpeningBalance",
            modelTitleKey: "title",
            modelName: "تراز افتتاحیه",
            hasSheets: true,
            modelTitles: [

                // {
                //     name: "id",
                //     label: "شناسه بانک",
                //     required: false,
                //     primary: true,
                //     sheetName: "بانک"
                // },
                {
                    name: "detailAccountingCodeBank",
                    label: "کد بانک",
                    required: false,
                    primary: true,
                    sheetName: "بانک"
                },
                {
                    name: "amountBank",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "بانک"
                },
                // {
                //     name: "id",
                //     label: "شناسه صندوق",
                //     required: false,
                //     primary: true,
                //     sheetName: "صندوق"
                // },
                {
                    name: "detailAccountingCodeCash",
                    label: "کد صندوق",
                    required: false,
                    primary: true,
                    sheetName: "صندوق"
                },
                {
                    name: "amountCash",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "صندوق"
                },
                {
                    name: "amountDebtor",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "بدهکاران"
                },
                {
                    name: "detailAccountingCodePerson",
                    label: "کد شخص",
                    required: false,
                    primary: true,
                    sheetName: "بدهکاران"
                },
                // {
                //     name: "id",
                //     label: "شناسه تنخواه گردان",
                //     required: false,
                //     primary: true,
                //     sheetName: "تنخواه"
                // },
                {
                    name: "detailAccountingCodeTankhah",
                    label: "کد تنخواه گردان",
                    required: false,
                    primary: true,
                    sheetName: "تنخواه"
                },
                {
                    name: "amountTanKhah",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "تنخواه"
                },
                // {
                //     name: "id",
                //     label: "شناسه کالا",
                //     required: false,
                //     primary: true,
                //     sheetName: "موجودی کالا"
                // },
                {
                    name: "detailAccountingCodeProduct",
                    label: "کد کالا",
                    required: false,
                    primary: true,
                    sheetName: "موجودی کالا"
                },
                {
                    name: "amountProduct",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "موجودی کالا"
                },
                {
                    name: "quantity",
                    label: "تعداد/مقدار",
                    required: false,
                    primary: true,
                    sheetName: "موجودی کالا"
                },
                // {
                //     name: "wareHouseId",
                //     label: "شناسه انبار",
                //     required: false,
                //     primary: true,
                //     sheetName: "موجودی کالا"
                // },
                {
                    name: "wareHouseaccountingCode",
                    label: "کد انبار",
                    required: false,
                    primary: true,
                    sheetName: "موجودی کالا"
                },
                // {
                //     name: "detailAccountingCodeRecive",
                //     label: "",
                //     required: false,
                //     primary: true,
                //     sheetName: "اسناد دریافتنی"
                // },
                {
                    name: "detailAccountingCodePersonRecive",
                    label: "پرداخت کننده",
                    required: false,
                    primary: true,
                    sheetName: "اسناد دریافتنی"
                },
                {
                    name: "chequeNumberRecive",
                    label: "شماره",
                    required: false,
                    primary: true,
                    sheetName: "اسناد دریافتنی"
                },
                {
                    name: "amountRecive",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "اسناد دریافتنی"
                },
                {
                    name: "chequeDateRecive",
                    label: "تاریخ",
                    required: false,
                    primary: true,
                    sheetName: "اسناد دریافتنی"
                },
                {
                    name: "chequeIssueBankRecive",
                    label: "بانک",
                    required: false,
                    primary: true,
                    sheetName: "اسناد دریافتنی"
                },
                {
                    name: "chequeBranchRecive",
                    label: "شعبه",
                    required: false,
                    primary: true,
                    sheetName: "اسناد دریافتنی"
                },
                {
                    name: "detailAccountingCodePersonReciveing",
                    label: "پرداخت کننده",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "chequeNumberReciveing",
                    label: "شماره",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "amountReciveing",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "chequeDateReciveing",
                    label: "تاریخ واگذاری",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "chequeIssueBankReciveing",
                    label: "بانک",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "chequeBranchReciveing",
                    label: "شعبه",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "chequeBankReciveing",
                    label: "بانک در جریان وصول",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "detailAccountingCodePersonReceiving",
                    label: "پرداخت کننده",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },
                {
                    name: "chequeBranch",
                    label: "شعبه",
                    required: false,
                    primary: true,
                    sheetName: "اسناد در حال وصول"
                },

                {
                    name: "accountingCodeOtherAssets",
                    label: "کد حساب",
                    required: false,
                    primary: true,
                    sheetName: "سایر دارایی ها"
                },
                {
                    name: "tafsilCodeOtherAssets",
                    label: "کد تفصیل",
                    required: false,
                    primary: true,
                    sheetName: "سایر دارایی ها"
                },
                {
                    name: "descriptionOtherAssets",
                    label: "شرح",
                    required: false,
                    primary: true,
                    sheetName: "سایر دارایی ها"
                },
                {
                    name: "debtorOtherAssets",
                    label: "بدهکار",
                    required: false,
                    primary: true,
                    sheetName: "سایر دارایی ها"
                },
                {
                    name: "creditorOtherAssets",
                    label: "بستانکار",
                    required: false,
                    primary: true,
                    sheetName: "سایر دارایی ها"
                },
                {
                    name: "detailAccountingCodePersonCreditor",
                    label: "کد شخص",
                    required: false,
                    primary: true,
                    sheetName: "بستانکاران"
                },
                {
                    name: "amountCreditor",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "بستانکاران"
                },
                {
                    name: "detailAccountingCodeBankPayment",
                    label: "کد بانک",
                    required: false,
                    primary: true,
                    sheetName: "اسناد پرداختنی"
                },
                {
                    name: "recieverPayment",
                    label: "دروجه",
                    required: false,
                    primary: true,
                    sheetName: "اسناد پرداختنی"
                },
                {
                    name: "numberPayment",
                    label: "شماره",
                    required: false,
                    primary: true,
                    sheetName: "اسناد پرداختنی"
                },
                {
                    name: "amountPayment",
                    label: "مبلغ",
                    required: false,
                    primary: true,
                    sheetName: "اسناد پرداختنی"
                },
                {
                    name: "DatePayment",
                    label: "تاریخ",
                    required: false,
                    primary: true,
                    sheetName: "اسناد پرداختنی"
                },
                {
                    name: "accountingCodedebtor",
                    label: "کد حساب",
                    required: false,
                    primary: true,
                    sheetName: "سایر بدهی ها"
                },
                {
                    name: "tafsilCodedebtor",
                    label: "کد تفصیل",
                    required: false,
                    primary: true,
                    sheetName: "سایر بدهی ها"
                },
                {
                    name: "descriptiondebtor",
                    label: "شرح",
                    required: false,
                    primary: true,
                    sheetName: "سایر بدهی ها"
                },
                {
                    name: "debtordebtor",
                    label: "بدهکار",
                    required: false,
                    primary: true,
                    sheetName: "سایر بدهی ها"
                },
                {
                    name: "creditordebtor",
                    label: "بستانکار",
                    required: false,
                    primary: true,
                    sheetName: "سایر بدهی ها"
                },



            ],
        },
    },
    // {
    //     name: 'factor',
    //     value: 'factor',
    //     label: 'فاکتور',
    //     form: factorFormData,
    // },
    // {
    //     name: 'transaction',
    //     value: 'transaction',
    //     label: 'تراکنش',
    //     form: transactionFormData,
    // },
    // {
    //     name: 'transfer',
    //     value: 'transfer',
    //     label: 'انتقال',
    //     form: transferFormData,
    // },
    // {
    //     name: 'remittance',
    //     value: 'remittance',
    //     label: 'حواله',
    //     form: remittanceFormData,
    // },
    // {
    //     name: 'accounting',
    //     value: 'accounting',
    //     label: 'اسناد حسابداری',
    //     form: accountingFormData,
    // },
];
const SynchronizeComponent = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const excelReducer = useSelector((state) => state).excelReducer;
    const formikContext: any = useFormikContext();
    const values = formikContext.values

    //@ts-ignore
    const exportFormTitles = (form, titles = []) => {
        Object.values(form).map((input) => {
            //@ts-ignore
            if (input && input.name && input.label) {
                //@ts-ignore
                titles.push({
                    //@ts-ignore
                    name: `${excelReducer.activeTab?.key}_${input.name}`,
                    //@ts-ignore
                    label: input.label,
                    //@ts-ignore
                    required: input.required ?? false,
                    //@ts-ignore
                    primary: input.primary ?? false,
                    //@ts-ignore
                    options: input.options ?? undefined,
                });
            } else if (!(!input || typeof input === "string")) {
                exportFormTitles(input, titles);
            }
        });
        return titles;
    };

    //@ts-ignore
    const compareTitles = (modelTitles, excelTitles) => {
        //@ts-ignore
        modelTitles.map((m) => {
            //@ts-ignore
            const column = excelTitles.find((e) => e === m.label);
            // @ts-ignore
            // formikContext.setFieldValue(m.name, column ?? 'default')
            // formValues[m.name.split('.')[1]] = column ?? 'default'
            formikContext.setFieldValue(m.name, column ?? "default");
        });
    };

    //@ts-ignore
    const changeActiveTab = (tab) => {
        //@ts-ignore
        dispatch(excelSetTab(tab));
    };

    //@ts-ignore
    const changeFormValue = (value, name) => {
        if (excelReducer.activeTab) {
            //@ts-ignore
            let formValues = formikContext.values[excelReducer.activeTab?.key] ?? {};
            if (name === `${excelReducer.activeTab?.key}_table`) {
                //@ts-ignore
                const modelFormData = tables.find((t) => t.value === value);
                if (modelFormData) {
                    //@ts-ignore
                    formValues = {
                        ...formValues,
                        ...modelFormData.form,
                        modelTitles: exportFormTitles(modelFormData.form.modelTitles),
                    };
                    const activeSheet = hasSheets ? excelReducer.activeTab?.sheets.find((x:any) => x.key === values.sheet): excelReducer.activeTab?.sheets[0]
                    //@ts-ignore
                    compareTitles(formValues["modelTitles"],activeSheet.titles);
                    //compareTitles(formValues["modelTitles"], excelReducer.activeTab?.sheets[0].titles);
                }
                formikContext.setFieldValue(excelReducer.activeTab?.key, formValues);
            }
            formikContext.setFieldValue(name, value);
        }
    };
    useEffect(() => {
        //@ts-ignore
        //dispatch(excelSetTab(excelReducer.excelData[0]));
    }, []);
    const getExcelSheets = () => {
        return excelReducer.excelData[0].sheets.map((x: any) => {
            return {
                label: x.key,
                value: x.key,
            }
        })
    }
    const hasSheets = formikContext?.values[formikContext?.values["colSelected"]].hasSheets === true
    const modelData = formikContext?.values[formikContext?.values["colSelected"]]?.modelTitles
    //@ts-ignore
    const selectOptions = (item) => {
        let options = [
            {
                label: "خالی",
                value: null,
            },
        ];
        if (hasSheets) {
            const currentSheet = excelReducer.activeTab?.sheets.find((x: any) => x.key === values.sheet)
            options = [
                ...options,
                ...currentSheet?.titles?.map((title: typeof String) => ({
                    label: title,
                    value: title,
                })),
            ];
            return options
        }
        if (item.options && Array.isArray(item.options)) {
            options = [...options, ...item.options];
        } else {
            options = [
                ...options,
                ...excelReducer.activeTab?.sheets[0]?.titles?.map((title: typeof String) => ({
                    label: title,
                    value: title,
                })),
            ];
        }

        return options;
    };
    console.log(formikContext?.values[formikContext.values["colSelected"]]?.modelTitles)
    return (
        <Form style={{ direction: "rtl" }}>
            <Container maxWidth="md">
                {/* <TableTabs

                    tabs={excelReducer.excelData}data must be changed 
                    activeTab={excelReducer.activeTab}
                    activeTabKey={excelReducer.activeTab?.key}
                    setActiveTab={changeActiveTab}
                /> */}
            </Container>
            <UploadComponentContainer>
                {
                    hasSheets &&
                    < div className="flex">
                        <StyledSelect key={"ffffffffffffff"}>
                            <SelectInput
                                name={
                                    "sheet"
                                }
                                label={"انتخاب صفحه"}
                                selectOption={getExcelSheets()}
                                onChange={changeFormValue}
                            />
                        </StyledSelect>
                    </div>}
                <TableElementsContainer>
                    <TableLablesItemContainer>
                        <LabelHeader>
                            <Typography variant="body2">عنوان جدول</Typography>
                        </LabelHeader>

                        {
                            //@ts-ignore
                            !formikContext?.values["colSelected"] ? null : (
                                <>
                                    {
                                        hasSheets ?
                                            //@ts-ignore
                                            modelData.filter((x: any) => x.sheetName === values?.sheet).map((item) => {
                                                return (
                                                    <LabelBodyItem key={shortid.generate()}>
                                                        <Typography variant="body2">
                                                            {
                                                                //@ts-ignore
                                                                item.label + (item.required ? " *" : "")
                                                            }
                                                        </Typography>
                                                    </LabelBodyItem>
                                                );
                                            }) :
                                            //@ts-ignore
                                            modelData.map((item) => {
                                                return (
                                                    <LabelBodyItem key={shortid.generate()}>
                                                        <Typography variant="body2">
                                                            {
                                                                //@ts-ignore
                                                                item.label + (item.required ? " *" : "")
                                                            }
                                                        </Typography>
                                                    </LabelBodyItem>
                                                );
                                            })
                                    }
                                </>
                            )
                        }
                    </TableLablesItemContainer>
                    <TableValuesItemContainer>
                        <LabelHeader>
                            <Typography variant="body2">ستون های فایل</Typography>
                            {/*<Typography variant='caption'>*/}
                            {/*    {modelTitles.length} / {*/}
                            {/*    //@ts-ignore*/}
                            {/*    Object.keys(formikContext?.values).length*/}
                            {/*}*/}
                            {/*</Typography>*/}
                        </LabelHeader>
                        {/* <StyledSelect>
                            <SelectInput
                                name={`${excelReducer.activeTab?.key}_table`}
                                label={""}
                                onChange={changeFormValue}
                                selectOption={tables}
                            />
                        </StyledSelect> */}
                        {
                            //@ts-ignore
                            !formikContext?.values[formikContext.values["colSelected"]]?.table ? null : (
                                <>
                                    {
                                        hasSheets ?
                                            //@ts-ignore
                                            modelData.filter((x: any) => x.sheetName === values?.sheet).map((item, index) => {

                                                return <StyledSelect key={index}>
                                                    <SelectInput
                                                        name={
                                                            //@ts-ignore
                                                            item.name
                                                        }
                                                        label={""}
                                                        //@ts-ignore
                                                        onChange={(value, name) => {
                                                            changeFormValue(value, name)
                                                        }}
                                                        //@ts-ignore
                                                        selectOption={selectOptions(item)}
                                                    />
                                                </StyledSelect>


                                            }) :
                                            //@ts-ignore
                                            modelData.map((item, index) => {
                                                return (
                                                    <StyledSelect key={index}>
                                                        <SelectInput
                                                            name={
                                                                //@ts-ignore
                                                                item.name
                                                            }
                                                            label={""}
                                                            onChange={changeFormValue}
                                                            //@ts-ignore
                                                            selectOption={selectOptions(item)}
                                                        />
                                                    </StyledSelect>
                                                );
                                            })
                                    }

                                </>
                            )
                        }
                    </TableValuesItemContainer>
                </TableElementsContainer>
                {/* <ProductListContainer>
                    <ProductLabelContainer>
                        {
                            //@ts-ignore
                            formikContext?.values[formikContext.values["colSelected"]]?.modelName
                                ? "لیست " + formikContext?.values[formikContext.values["colSelected"]]?.modelName
                                : ""
                        }
                    </ProductLabelContainer>
                    <ProductList>
                        {
                            //@ts-ignore
                            excelReducer.activeTab?.sheets[0]?.items.map((item, index) => {
                                //@ts-ignore
                                const titleColumn =
                                    formikContext?.values[
                                    `${excelReducer.activeTab?.key}_${formikContext?.values[excelReducer.activeTab?.key]?.modelTitleKey
                                    }`
                                    ];
                                return (
                                    <ProductItem key={index}>
                                        <ProductAvatar src="./assets/images/product-bg.png" />
                                        <Typography variant="body2">
                                            {
                                                //@ts-ignore
                                                item[titleColumn] ?? ""
                                            }
                                        </Typography>
                                    </ProductItem>
                                );
                            })
                        }
                    </ProductList>
                </ProductListContainer> */}
            </UploadComponentContainer>
        </Form >
    );
};

export default SynchronizeComponent;

const ActionContainer = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 2,
}));

export const SynchronizeAction = ({ onSubmit, onIgnore }: { onSubmit: () => void; onIgnore: () => void }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    //@ts-ignore
    const sendingRequest = useSelector((state) => state).appReducer.sendingRequest;
    //@ts-ignore
    const token = useSelector((state) => state).businessReducer.business?.token;
    //@ts-ignore
    const excelReducer = useSelector((state) => state).excelReducer;

    const [modelTitles, setModelTitles] = useState([]);
    const [requiredFields, setRequiredFields] = useState([]);
    //@ts-ignore
    const formikContext: any = useFormikContext();

    //@ts-ignore
    const exportFormTitles = (form, titles = []) => {
        Object.values(form).map((input) => {
            //@ts-ignore
            if (input && input.name && input.label) {
                //@ts-ignore
                titles.push({
                    //@ts-ignore
                    name: input.name,
                    //@ts-ignore
                    label: input.label,
                    //@ts-ignore
                    required: input.required ?? false,
                    //@ts-ignore
                    primary: input.primary ?? false,
                });
            } else if (!(!input || typeof input === "string")) {
                exportFormTitles(input, titles);
            }
        });
        return titles;
    };
    const hasSheets = formikContext?.values[formikContext?.values["colSelected"]].hasSheets === true

    useEffect(() => {
        //@ts-ignore
        if (formikContext.values[excelReducer.activeTab?.key]) {
            //@ts-ignore
            const modelTitles = formikContext.values[excelReducer.activeTab?.key]["modelTitles"];
            //@ts-ignore
            setRequiredFields(modelTitles.filter((m) => m.required === true).map((m) => m.name));
        }
    }, [excelReducer.activeTab]);

    return (
        <ActionContainer>
            <Button
                variant="outlined"
                color="disabled"
                disableRipple
                disableElevation
                sx={{ borderWidth: "3px !important" }}
                disableFocusRipple
                onClick={() => onIgnore()}
            >
                بازگشت
            </Button>
            {/* @ts-ignore */}
            <Button
                variant="contained"
                disabled={sendingRequest}
                startIcon={
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.95357 1.36364C2.53163 1.36364 2.12698 1.53125 1.82863 1.8296C1.53027 2.12796 1.36266 2.53261 1.36266 2.95455V17.0455C1.36267 17.428 1.50053 17.7977 1.75097 18.0869C2.00141 18.3761 2.34767 18.5654 2.7263 18.62V12.0455C2.7263 11.503 2.9418 10.9827 3.3254 10.5991C3.70899 10.2155 4.22926 10 4.77175 10H15.2263C15.7688 10 16.2891 10.2155 16.6727 10.5991C17.0562 10.9827 17.2718 11.503 17.2718 12.0455V18.62C17.6504 18.5654 17.9966 18.3761 18.2471 18.0869C18.4975 17.7977 18.6354 17.428 18.6354 17.0455V5.26C18.6354 4.83727 18.4681 4.43273 18.169 4.13455L15.8645 1.83C15.7167 1.68214 15.5413 1.56484 15.3482 1.48482C15.155 1.4048 14.9481 1.36362 14.739 1.36364H14.5445V5.22727C14.5445 5.49589 14.4916 5.76187 14.3888 6.01003C14.286 6.2582 14.1353 6.48369 13.9454 6.67363C13.7554 6.86357 13.53 7.01423 13.2818 7.11703C13.0336 7.21982 12.7676 7.27273 12.499 7.27273H6.58993C6.04744 7.27273 5.52718 7.05722 5.14358 6.67363C4.75998 6.29003 4.54448 5.76976 4.54448 5.22727V1.36364H2.95357ZM5.90811 1.36364V5.22727C5.90811 5.60364 6.21357 5.90909 6.58993 5.90909H12.499C12.6799 5.90909 12.8533 5.83726 12.9811 5.70939C13.109 5.58153 13.1808 5.4081 13.1808 5.22727V1.36364H5.90811ZM15.9081 18.6364V12.0455C15.9081 11.8646 15.8363 11.6912 15.7084 11.5633C15.5805 11.4355 15.4071 11.3636 15.2263 11.3636H4.77175C4.59092 11.3636 4.4175 11.4355 4.28963 11.5633C4.16177 11.6912 4.08993 11.8646 4.08993 12.0455V18.6364H15.9081ZM-0.000976562 2.95455C-0.000976563 2.17095 0.310305 1.41945 0.86439 0.865366C1.41847 0.311281 2.16997 0 2.95357 0H14.7399C15.5235 4.67926e-05 16.275 0.311359 16.829 0.865454L19.1336 3.17C19.6881 3.72455 19.999 4.47636 19.999 5.26V17.0455C19.999 17.8291 19.6877 18.5805 19.1337 19.1346C18.5796 19.6887 17.8281 20 17.0445 20H2.95357C2.16997 20 1.41847 19.6887 0.86439 19.1346C0.310305 18.5805 -0.000976562 17.8291 -0.000976562 17.0455V2.95455Z"
                            fill="#fff"
                        />
                    </svg>
                }
                onClick={() => {
                    let valid = true;
                    requiredFields.map((rf) => {
                        //@ts-ignore
                        if (!formikContext.values[rf] || formikContext.values[rf] === "default") {
                            valid = false;
                        }
                    });

                    if (valid) {
                        //@ts-ignore
                        const items: any[] = [];
                        let table
                        //@ts-ignore
                        if (hasSheets) {
                            excelReducer.excelData?.find((ed: any) => ed.key === excelReducer.activeTab?.key)
                                ?.sheets.map((sheet: any,index:number) => {
                                    sheet.items.map((i: any, index: number) => {
                                        let item = {
                                            index,
                                            main: {},
                                            others: {
                                                //@ts-ignore
                                                formType: formikContext.values[formikContext.values["colSelected"]].table,
                                            },
                                        };
                                        //@ts-ignore
                                        formikContext.values[formikContext.values["colSelected"]].modelTitles.map((mt) => {
                                            //@ts-ignore
                                            if (formikContext.values[`${mt.name}`] && formikContext.values[`${mt.name}`] !== null) {
                                                //@ts-ignore
                                                const target = mt.primary ? "main" : "others";
                                                let nameArray = mt.name.split("_")
                                                //@ts-ignore
                                                item[target][nameArray[nameArray.length - 1]] = mt.options
                                                    ? formikContext.values[`${mt.name}`]
                                                    : i[formikContext.values[mt.name]] ?? null;
                                            }
                                        });
                                        Object.assign(item,{key:sheet.key})
                                        items.push(item);
                                    });
                                })
                            //@ts-ignore
                            table = tables.find(
                                (t) => t.value === formikContext.values[`${formikContext.values["colSelected"]}`]?.table
                            );
                        } else {

                            excelReducer.excelData
                                ?.find((ed: any) => ed.key === excelReducer.activeTab?.key)
                                ?.sheets[0].items.map((i: any, index: number) => {

                                    let item = {
                                        index,
                                        main: {},
                                        others: {
                                            //@ts-ignore
                                            formType: formikContext.values[formikContext.values["colSelected"]].table,
                                        },
                                    };
                                    //@ts-ignore
                                    formikContext.values[formikContext.values["colSelected"]].modelTitles.map((mt) => {
                                        //@ts-ignore
                                        if (formikContext.values[`${mt.name}`] && formikContext.values[`${mt.name}`] !== null) {
                                            //@ts-ignore
                                            const target = mt.primary ? "main" : "others";
                                            let nameArray = mt.name.split("_")
                                            //@ts-ignore
                                            item[target][nameArray[nameArray.length - 1]] = mt.options
                                                ? formikContext.values[`${mt.name}`]
                                                : i[formikContext.values[mt.name]] ?? null;
                                        }
                                    });
                                    items.push(item);
                                });
                            //@ts-ignore
                            table = tables.find(
                                (t) => t.value === formikContext.values[`${formikContext.values["colSelected"]}`]?.table
                            );
                        }
                        //@ts-ignore
                        table &&
                            dispatch(
                                // @ts-ignore
                                table.addFunction(items, token, (items: any) => {
                                    // @ts-ignore
                                    dispatch(excelSetItems(items));
                                    //@ts-ignore
                                    onSubmit(items);
                                })
                            );
                    } else {
                        // @ts-ignore
                        dispatch(apiSetAlert("لطفا مقدار عناوین اجباری را انتخاب نمایید", "warning"));
                    }
                    // onSubmit()
                }}
                disableRipple
                disableElevation
                disableFocusRipple
                sx={{ borderWidth: "3px !important" }}
            >
                &nbsp;&nbsp;
                {
                    //@ts-ignore
                    formikContext.values[excelReducer.activeTab?.key]
                        ? " ثبت " +
                        (excelReducer.excelData?.find((ed: any) => ed.key === excelReducer.activeTab?.key)?.sheets[0]
                            ?.items.length ?? 0) +
                        " " +
                        (excelReducer.activeTab?.key
                            ? formikContext.values[excelReducer.activeTab?.key]?.modelName
                            : "")
                        : "ثبت"
                }
            </Button>
        </ActionContainer>
    );
};
